module.exports = __webpack_public_path__ + "img/LPTemp5.a1a4dea9.png";